{
  "accountBlocked": "खाता ब्लॉक कर दिया गया है",
  "accountInactive": "खाता निष्क्रिय है",
  "alreadyHaveAccount": "पहले से खाता है?",
  "backToLogin": "लॉगिन पर वापस जाएं",
  "backupCode": "बैकअप कोड",
  "confirmPassword": "पासवर्ड की पुष्टि करें",
  "continue": "जारी रखें",
  "createAccount": "खाता बनाएं",
  "creatingAccount": "खाता बनाया जा रहा है...",
  "dontHaveAccount": "खाता नहीं है?",
  "email": "ईमेल",
  "emailAddress": "ईमेल पता",
  "emailAlreadyExists": "यह ईमेल पहले से मौजूद है",
  "emailNotVerified": "ईमेल सत्यापित नहीं है",
  "enter2FACode": "6 अंकों का सत्यापन कोड दर्ज करें",
  "forgotPassword": "पासवर्ड भूल गए",
  "invalid2FACode": "सत्यापन कोड अमान्य है",
  "invalidCredentials": "ईमेल या पासवर्ड गलत है",
  "loggingIn": "लॉगिन हो रहा है...",
  "login": "लॉगिन",
  "loginNow": "अभी लॉगिन करें",
  "loginProtected": "आपका खाता Google Authenticator द्वारा सुरक्षित है।",
  "loginRequired": "मूल्य अलर्ट बनाने के लिए कृपया लॉगिन करें।",
  "loginSuccessful": "लॉगिन सफल रहा",
  "logout": "लॉगआउट",
  "password": "पासवर्ड",
  "pleaseWait": "कृपया प्रतीक्षा करें...",
  "rememberMe": "मुझे याद रखें",
  "resetPassword": "पासवर्ड रीसेट करें",
  "sendCode": "कोड भेजें",
  "sending": "भेजा जा रहा है...",
  "sessionExpired": "सत्र समाप्त हो गया है। कृपया पुनः लॉगिन करें।",
  "signup": "साइन अप",
  "signupNow": "अभी साइन अप करें",
  "signupSuccessful": "खाता सफलतापूर्वक बनाया गया",
  "twoFactorAuthentication": "दो-चरणीय सत्यापन",
  "verify": "सत्यापित करें",
  "verify2FA": "2FA सत्यापित करें",
  "verifyEmail": "ईमेल वेरिफाई करें",
  "verifyResetCode": "रीसेट कोड सत्यापित करें"
}